/* eslint-disable import/prefer-default-export */
import { useCohesion } from './hooks/use-cohesion';

export { useCohesion };
